import { Button, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { conferenceOptions } from '@/module/Nomen/Conference/model/ConferenceModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ConferenceSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ConferenceSelectControl<T extends FieldValues>(props: ConferenceSelectControlProps<T>) {
  const { data, isLoading, isError, refetch } = useQuery(conferenceOptions.getAll());
  const { t } = useTranslation();
  const [hasAddedNew, setHasAddedNew] = useState(false);

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      description={t('conferences.select.limit')}
      limit={100}
      nothingFoundMessage={
        <Stack>
          <Text ta="center">{t('conferences.select.nothingFound')}</Text>
          {!hasAddedNew && (
            <Button
              size="xs"
              onClick={() => {
                window.open('/conference/create');
                setHasAddedNew(true);
              }}
            >
              {t('button.add')}
            </Button>
          )}
          {hasAddedNew && <Button onClick={() => refetch()}>Refresh</Button>}
        </Stack>
      }
      options={(data ?? []).map(j => ({ id: j.id, name: j.conferenceName }))}
      {...props}
    />
  );
}
